import { Field } from '../domain/Field';
import { Widget } from '../widget/widget';
import { WidgetFactory } from '../widget/WidgetFactory';
import { TypeInfo } from './TypeInfo';

export class Bool extends TypeInfo {
	constructor() {
		super();
	}

	canAcceptValue(value: any): boolean {
		return typeof(value) == 'boolean';
	}

	getDefaultValue(): any {
		return false;
	}

	toString(): string {
		return 'bool';
	}

	createWidget(field: Field): Widget {
		return WidgetFactory.createBool(field);
	}
}
